<template>
    <div class="workout">
        <transition name="modal">
            <div class="modal-mask" v-if="showModal">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <div class="modal-header">
                            <h4>IMPORTANT NOTICE</h4>
                        </div>
                        <div class="modal-body">
                            <p>Always ensure you warm up and cool down after every workout to reduce the risk of injury.</p>
                        </div>
                        <div class="modal-footer">
                            <slot name="footer">
                                <button class="modal-default-button" @click="closeModal()">OK</button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-mask" v-if="showCompleteModal">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <div class="modal-header">
                            <h4>
                                <strong>WELL DONE - YOU DID IT!</strong>
                            </h4>
                        </div>
                        <div class="modal-body">
                            <p>Congratulations on completing your Workout@Home</p>
                            <p>Why not
                                <strong>challenge your friends</strong> to give your workout a try. You can share on
                                <strong>Facebook</strong> or
                                <strong>Twitter</strong> by clicking on the icons below.
                            </p>
                            <social-sharing :url="shareSite + '' + shareLink + '?routine=' + queryString" :title="`I just finished my Workout@Home with `+ socialMediaName +` and now i'm challenging you to give the same workout a try!`" :hashtags="socialMediaHashtag" inline-template>
                                <div>
                                    <network network="facebook">
                                        <font-awesome-icon :icon="['fab', 'facebook-f']" />
                                    </network>
                                    <network network="twitter">
                                        <font-awesome-icon :icon="['fab', 'twitter']" />
                                    </network>
                                </div>
                            </social-sharing>
                        </div>
                        <div class="modal-footer">
                            <slot name="footer">
                                <button
                                class="modal-default-button"
                                @click="function(){showCompleteModal = false}"
                                >OK</button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-mask" v-if="showIOSModal">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <div class="modal-body">
                            <IOSModalBody v-bind:close="closeIOSModal" />
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <div class="container px-0 px-sm-3">
            <form class="workout_filters">
                <div class="form-check form-check-inline">
                    <label class="form-check-label" for="cardioRadio">Cardio</label>
                    <input class="form-check-input" name="workout-filter" type="checkbox" id="cardioRadio" v-model="filtersBy" value="cardio" />
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label" for="coreRadio">Core</label>
                    <input class="form-check-input" name="workout-filter" type="checkbox" id="coreRadio" v-model="filtersBy" value="core" />
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label" for="StrengthRadio">Strength</label>
                    <input class="form-check-input" name="workout-filter" type="checkbox" id="StrengthRadio" v-model="filtersBy" value="strength" />
                </div>
                <div class="form-check form-check-inline">
                    <label class="form-check-label" for="mindRadio">Warm Up</label>
                    <input class="form-check-input" name="workout-filter" type="checkbox" id="mindRadio" v-model="filtersBy" value="warm" />
                </div>
                <button type="button" name="button" @click="createRandomWorkout()" :disabled="disableRandomiserButton">Random Workout</button>
            </form>

            <div class="classes_list">
                <carousel :perPageCustom="[ [0, 1], [768, 2], [1200, 3] ]" :navigationEnabled="true" :paginationEnabled="false" navigationNextLabel=">" navigationPrevLabel="<">
                    <slide v-for="(workout, index) in filteredWorkouts" :key="workout.class" :data-index="index" :data-name="workout.class">
                        <img :src="'https://bigwavemedia.co.uk/workoutathome_system/images/' + imageDirectory + '/' + workout.image" />
                        <button type="button" @click="handleWorkoutClick(index, workout.class)">Add Exercise</button>
                    </slide>
                </carousel>
                <transition name="fade" mode="out-in">
                    <div v-show="showExerciseAdd" class="success_add">
                        <font-awesome-icon icon="check" />
                    </div>
                </transition>
                <h3>BUILD YOUR WORKOUT BELOW</h3>
            </div>
        </div>

        <transition name="slide">
            <div v-if="chosenClasses.length > 0">
                <div class="workout_basket">
                    <div class="basket_container">
                        <h3 id="yourWorkout">Your workout today is…</h3>
                        <div class="container">
                            <transition-group name="fade" mode="out-in" tag="ul" :class="chosenClasses.length < 4 ? 'narrow' : ''">
                            <li v-for="(choice, index) in chosenClasses" :key="choice.name + '_' + index">
                                <img :src="'https://bigwavemedia.co.uk/workoutathome_system/images/' + imageDirectory + '/' + allClasses[choice.index].image" />
                                <button type="button" @click="removeClass(index)">Remove Exercise</button>
                            </li>
                        </transition-group>
                    </div>
                </div>
            </div>

            <div class="lets_workout">
                <div class="container">
                    <div class="row">
                        <div class="order-2 order-sm-1 col-12 col-sm-6" :class="chosenClasses[workoutStage + 1] ? 'col-lg-4' : 'col-lg-6'">
                        <div class="workout_instructions">
                            <div class="workout_steps">
                                <h3>HOW TO DO THIS EXERCISE</h3>
                                <div>
                                    <span class="step_a">A</span>
                                    <p>{{allClasses[chosenClasses[workoutStage].index].instructions[0]}}</p>
                                </div>
                                <div>
                                    <span class="step_b">B</span>
                                    <p>{{allClasses[chosenClasses[workoutStage].index].instructions[1]}}</p>
                                </div>
                                <div class="pro_tip">
                                    <p>PRO TIP: {{allClasses[chosenClasses[workoutStage].index].pro_tip}}</p>
                                </div>
                                <div class="start_workout">
                                    <div class="row">
                                        <div class="col-6">
                                            <transition name="fade">
                                                <div class="timer_display d-none d-sm-block" v-if="display">
                                                    <strong>{{display}}</strong>
                                                </div>
                                            </transition>
                                        </div>

                                        <div class="col-6">
                                            <transition name="fade">
                                                <div class="timer_display d-none d-sm-flex text-align-center h-100 align-items-center justify-content-center" v-if="display">
                                                <h4>{{workoutStageDisplay}}</h4>
                                            </div>
                                        </transition>
                                    </div>

                                    <div :class="!display ? 'col-12' : 'col-6'">
                                        <button class="d-none d-sm-block" type="button" name="button" @click="beginWorkout()" :disabled="disableButton">{{buttonText}}</button>
                                    </div>

                                    <div class="col-6">
                                        <transition name="fade">
                                            <div class="timer_display d-none d-sm-block" v-if="display">
                                                <button class="d-block" type="button" @click="paused = !paused">
                                                    <font-awesome-icon v-if="!paused" icon="pause" />
                                                    <font-awesome-icon v-else icon="play" />
                                                </button>
                                            </div>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-1 order-sm-2 col-12 col-sm-6" :class="chosenClasses[workoutStage + 1] ? 'col-lg-4' : 'col-lg-6'">
                <div class="active_workout">
                    <div class="row">
                        <div class="col-6">
                            <transition name="fade">
                                <div class="timer_display d-block d-sm-none" v-if="display">
                                    <strong>{{display}}</strong>
                                </div>
                            </transition>
                        </div>

                        <div class="col-6">
                            <transition name="fade">
                                <div class="timer_display d-flex d-sm-none text-align-center h-100 align-items-center justify-content-center" v-if="display">
                                <h4>{{workoutStageDisplay}}</h4>
                            </div>
                        </transition>
                    </div>

                    <div :class="!display ? 'col-12' : 'col-6'">
                        <button class="d-block d-sm-none" type="button" name="button" @click="beginWorkout()" :disabled="disableButton">{{buttonText}}</button>
                    </div>

                    <div class="col-6">
                        <transition name="fade">
                            <div class="timer_display d-block d-sm-none" v-if="display">
                                <button class="d-block" type="button" @click="paused = !paused">
                                    <font-awesome-icon v-if="!paused" icon="pause" />
                                    <font-awesome-icon v-else icon="play" />
                                </button>
                            </div>
                        </transition>
                    </div>
                </div>

                <img :src="'https://bigwavemedia.co.uk/workoutathome_system/images/' + imageDirectory + '/' +  allClasses[chosenClasses[workoutStage].index].image" />
            </div>
        </div>
        <div class="order-3 d-none d-lg-block col-4">
            <div class="next_workout" v-if="chosenClasses[workoutStage + 1]">
                <div class="overlay"></div>
                <img :src="'https://bigwavemedia.co.uk/workoutathome_system/images/' + imageDirectory + '/' +  allClasses[chosenClasses[workoutStage + 1].index].image" />
            </div>
        </div>
    </div>
</div>
</div>

<div class="social_share">
    <div class="social">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2>Great Work</h2>

                    <div class="row">
                        <div class="col-12 col-md-6 offset-md-3">
                            <p>You did it… Why not share your workout with your friends and family.</p>
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <social-sharing :url="shareSite + '' + shareLink + '?routine=' + queryString" :title="`I just finished my Workout@Home with `+ socialMediaName +` and now i'm challenging you to give the same workout a try!`" :hashtags="socialMediaHashtag" inline-template>
                        <div>
                            <network network="facebook">
                                <font-awesome-icon :icon="['fab', 'facebook-f']" />
                            </network>
                            <network network="twitter">
                                <font-awesome-icon :icon="['fab', 'twitter']" />
                            </network>
                        </div>
                    </social-sharing>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
</transition>

<div class="footer">
    <span>Workout@Home Designed & Built by&nbsp;</span>
    <a href="https://www.bigwavemedia.co.uk" target="_blank" ><img src="bw-logo.png" /></a>
</div>
</div>
</template>

<script>
    import { Carousel, Slide } from "vue-carousel";
    import { Howl, Howler } from "howler";
    import IOSModalBody from "./IOSModalBody";

    export default {
        name: "Workout",

        components: {
            Carousel,
            Slide,
            IOSModalBody
        },

        methods: {
            closeModal: function() {
                this.showModal = false;
                if (!this.disclaimerShown) {
                    this.disclaimerShown = true;
                    this.beginWorkout();
                }
            },

            closeIOSModal: function() {
                this.showIOSModal = false;
                if (!this.disclaimerShown) {
                    this.disclaimerShown = true;
                    this.beginWorkout();
                }
            },

            buttonClickSound: function() {
                const sound = new Howl({
                    src: ["sounds/button_click.mp3"],
                    onplayerror: function() {
                        sound.once("unlock", function() {
                            sound.play();
                        });
                    }
                });
                sound.play();
            },

            countdownSoundAlt: function() {
                const sound = new Howl({
                    src: ["sounds/game_countdown_low.mp3"],
                    onplayerror: function() {
                        sound.once("unlock", function() {
                            sound.play();
                        });
                    }
                });
                sound.play();
            },

            countdownSound: function() {
                const sound = new Howl({
                    src: ["sounds/game_countdown.mp3"],
                    onplayerror: function() {
                        sound.once("unlock", function() {
                            sound.play();
                        });
                    }
                });
                sound.play();
            },

            newWorkoutSound: function() {
                const sound = new Howl({
                    src: ["sounds/menu_success.mp3"],
                    onplayerror: function() {
                        sound.once("unlock", function() {
                            sound.play();
                        });
                    }
                });
                sound.play();
            },

            completeSound: function() {
                const sound = new Howl({
                    src: ["sounds/quest_complete.mp3"],
                    onplayerror: function() {
                        sound.once("unlock", function() {
                            sound.play();
                        });
                    }
                });
                sound.play();
            },

            createRandomWorkout: function() {
                this.chosenClasses = [];
                this.queryString = "";

                var totalNumberRandom = this.chosenClasses.length;

                var exercises = [];
                for (var i = 0; i < 6 - totalNumberRandom; i++) {
                    const classesIndex = Math.floor(Math.random() * this.allClasses.length);
                    var randomClassData = {
                        name: this.allClasses[classesIndex].class,
                        index: classesIndex
                    };
                    this.chosenClasses.push(randomClassData);
                    exercises.push(classesIndex);
                }

                this.queryString = exercises.join(",");

                setTimeout(function() {
                    var element = document.getElementById("yourWorkout");
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "nearest"
                    });
                }, 500);
            },

            runTimer: function(arrPeriods, index) {
                var self = this;
                var timeDifference;

                var startTime = arrPeriods[index].time;

                var interval = setInterval(function() {
                    if (!self.paused) {
                        startTime--;
                        timeDifference = startTime;
                    } else {
                        timeDifference = startTime;
                    }

                    self.display = timeDifference;
                    self.workoutStageDisplay = arrPeriods[index].name;

                    if (timeDifference === 5) {
                        if (index < arrPeriods.length - 1) {
                            if (arrPeriods[index].name == "GO!") {
                                self.countdownSoundAlt();
                            } else {
                                self.countdownSound();
                            }
                        }
                    }

                    if (timeDifference === 1) {
                        clearInterval(interval);
                        if (index < arrPeriods.length - 1) {
                            index++;
                            self.runTimer(arrPeriods, index);
                        } else {
                            if (self.chosenClasses[self.workoutStage + 1]) {
                                self.workoutStage++;
                                self.disableButton = false;
                                self.workoutStageDisplay =
                                "Click to continue your workout";
                                self.newWorkoutSound();
                            } else {
                                self.completeSound();
                                self.workoutStageDisplay = "Workout Complete...";
                                self.showCompleteModal = true;
                            }
                            self.display = "0";
                            return;
                        }
                    }
                }, 1000);
            },

            runTabata: function(preparation, activity, rest, rounds) {
                this.buttonClickSound();
                var arrPeriods = [{ name: "Ready...", time: preparation }],
                index = 0;
                for (var i = 0; i < rounds; i++) {
                    arrPeriods.push({ name: "GO!", time: activity });
                    arrPeriods.push({ name: "Rest...", time: rest });
                }
                this.runTimer(arrPeriods, index);
            },

            beginWorkout: function() {
                if (!this.disclaimerShown) {
                    if (this.iOS) {
                        this.showIOSModal = true;
                    } else {
                        this.showModal = true;
                    }
                } else {
                    var workout = this.allClasses[
                    this.chosenClasses[this.workoutStage].index
                    ];
                    var workoutSteps = workout.total_time;
                    this.disableButton = true;
                    this.runTabata(
                    workoutSteps.prep,
                    workoutSteps.on,
                    workoutSteps.off,
                    workoutSteps.sets
                    );
                }
            },

            removeClass: function(removeIndex) {
                this.chosenClasses.splice(removeIndex, 1);
                var queryEdit = this.queryString.split(",");
                queryEdit.splice(removeIndex, 1);
                this.queryString = queryEdit.join(",");
            },

            handleWorkoutClick: function(index, className) {
                this.showExerciseAdd = true;
                this.buttonClickSound();

                if (this.chosenClasses.length > 5) {
                    alert("Please remove an exercise before adding another!");
                    return;
                }
                for (var x = 0; x < this.allClasses.length; x++) {
                    if (this.allClasses[x].class == className) {
                        var dataset = {
                            index: x,
                            class: className
                        };
                        this.chosenClasses.push(dataset);
                    }
                }
                var exercises = [];
                for (var i = 0; i < this.chosenClasses.length; i++) {
                    exercises.push(this.chosenClasses[i].index);
                }
                this.queryString = exercises.join(",");

                setTimeout(() => {
                    this.showExerciseAdd = false;
                }, 1250);
            },

            populateSharedRoutine: function(arr) {
                for (var i = 0; i < arr.length; i++) {
                    var data = {};
                    data.index = arr[i];
                    data.name = this.allClasses[arr[i]].class;
                    this.chosenClasses.push(data);
                }
            }
        },

        mounted: function() {

            Howler.autoUnlock = true;

            var self = this;

            this.axios.get('https://www.bigwavemedia.co.uk/workoutathome_system/bigwave/', {
                crossDomain: true,
            }).then(function(response) {
                self.allClasses = response.data;
                var urlParams = new URLSearchParams(window.location.search);
                var exercises = urlParams.get("routine");
                if (exercises) {
                    self.populateSharedRoutine(exercises.split(","));
                    self.queryString = exercises;
                }
            }).catch(function(e){
                console.log(e);
            });

        },

        computed: {
            filteredWorkouts: function() {
                if (this.filtersBy.length > 0) {
                    return this.allClasses.filter(obj => {
                        return this.filtersBy.some(r => obj.type.indexOf(r) >= 0);
                    });
                }
                return this.allClasses;
            }
        },

        data: function() {
            return {
                socialMediaName: process.env.VUE_APP_WAH_CLIENT_SOCIAL_NAME,
                socialMediaHashtag: process.env.VUE_APP_WAH_CLIENT_SOCIAL_HASHTAG,
                imageDirectory: process.env.VUE_APP_WAH_CLIENT_IMAGE_DIRECTORY,
                paused: false,
                showModal: false,
                showCompleteModal: false,
                showIOSModal: false,
                disclaimerShown: false,
                showExerciseAdd: false,
                disableRandomiserButton: false,
                disableButton: false,
                iOS: !!( /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) ),
                shareSite: window.location.protocol + "//" + window.location.hostname,
                shareLink: window.location.pathname,
                queryString: "",
                buttonText: "Start",
                display: "",
                workoutStageDisplay: "",
                workoutStage: 0,
                filtersBy: [],
                publicPath: process.env.BASE_URL,
                chosenClasses: [],
                allClasses: [],
            };
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    $white: #ffffff;
    $removeRed: #d80c6a;

    @mixin fontBlack {
        font-family: "Montserrat", sans-serif;
        font-weight: 900;
        font-style: normal;
    }

    @mixin fontBold {
        font-family: "Montserrat", sans-serif;
        font-weight: 700;
        font-style: normal;
    }

    @mixin fontMain {
        font-family: "Montserrat", sans-serif;
        font-weight: 400;
        font-style: normal;
    }

    .workout {
        padding-top: 30px;
        text-align: center;
        @media (min-width: 576px) {
            padding-top: 45px;
        }

        form.workout_filters {
            font-size: 18px;
            @include fontMain();
            padding: 0 15px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-bottom: 45px;
            @media (min-width: 1200px) {
                margin-bottom: 60px;
                padding: 0;
                display: block;
            }
            .form-check {
                background-color: $secondary;
                color: $white;
                padding: 0px 5px;
                border-radius: 25px;
                width: calc(50% - 4px);
                float: left;
                margin: 0;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin-bottom: 5px;
                &:nth-child(odd) {
                    margin-right: 2px;
                }
                &:nth-child(even) {
                    margin-left: 2px;
                }
                @media (min-width: 1200px) {
                    display: inline-block;
                    float: none;
                    margin: 0 5px 0 5px !important;
                    width: auto;
                }

                input {
                    cursor: pointer;
                    margin: 0 15px 0 10px;
                    text-align: right;
                    @media (min-width: 1200px) {
                        float: none;
                    }
                }
                label {
                    padding: 6px 10px;
                    text-align: left;
                    cursor: pointer;
                    @include fontBold();
                    width: 100%;
                    @media (min-width: 1200px) {
                        width: auto;
                    }
                }
            }

            button {
                @include fontBold();
                background-color: $primary;
                color: $white;
                border: none;
                border-radius: 25px;
                padding: 6px 10px;
                width: 100%;
                margin-left: 0;
                @media (min-width: 1200px) {
                    margin-left: 2px;
                    width: auto;
                }
            }
        }

        .classes_list {
            margin-bottom: 90px;
            position: relative;
            @media (min-width: 1200px) {
                margin-bottom: 120px;
            }
            h3 {
                margin-top: 60px;
                color: $secondary;
                padding: 0 15px;
                font-size: 20px;
                @include fontBlack();
            }

            @media (min-width: 768px) {
                &:before {
                    background-image: url("../../public/curve.png");
                    background-position: right;
                    background-repeat: no-repeat;
                    background-size: cover;
                    content: "";
                    position: absolute;
                    left: -35px;
                    top: -40px;
                    bottom: 0;
                    right: auto;
                    height: 100%;
                    z-index: 10;
                    width: 120px;
                }
                &:after {
                    background-image: url("../../public/curve.png");
                    background-position: right;
                    background-repeat: no-repeat;
                    background-size: cover;
                    transform: rotate(180deg);
                    content: "";
                    position: absolute;
                    left: auto;
                    top: -40px;
                    bottom: 0;
                    right: -35px;
                    height: 100%;
                    z-index: 10;
                    width: 120px;
                }
            }

            @media (min-width: 992px) {
                &:before {
                    left: 20px;
                }
                &:after {
                    right: 20px;
                }
            }

            @media (min-width: 1200px) {
                &:before {
                    left: -25px;
                }
                &:after {
                    right: -25px;
                }
            }

            .success_add {
                position: absolute;
                top: 45%;
                left: 50%;
                transform: translate(-50%, -50%);
                background-color: $primary;
                border: 6px solid $white;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 60px;
                height: 180px;
                width: 180px;
                @media (min-width: 768px) {
                    border: 12px solid $white;
                    font-size: 72px;
                    height: 200px;
                    width: 200px;
                }
                svg {
                    color: $white;
                }
            }
            .VueCarousel-navigation-button {
                border: none;
                z-index: 999;
                border-radius: 25px;
                background: $primary;
                width: 40px;
                height: 40px;
                color: $white;
                font-weight: bold;
                transition: all 0.3s ease;
                line-height: 20px;
                &:hover {
                    background: darken($primary, 10%);
                }
            }
            .VueCarousel-navigation-button.VueCarousel-navigation-next {
                right: 45px;
                font-size: 24px;
                @media (min-width: 576px) {
                    right: 12px;
                }
                @media (min-width: 1200px) {
                    font-size: 20px;
                    right: 18px;
                }
            }
            .VueCarousel-navigation-button.VueCarousel-navigation-prev {
                font-size: 24px;
                left: 45px;
                @media (min-width: 576px) {
                    left: 12px;
                }
                @media (min-width: 1200px) {
                    font-size: 20px;
                    left: 18px;
                }
            }
            .VueCarousel-slide {
                backface-visibility: visible;
                position: relative;
                &:hover {
                    button {
                        @media (min-width: 1200px) {
                            opacity: 1;
                            visibility: visible;
                            z-index: 1;
                        }
                    }
                }
                img {
                    max-height: 620px;
                    cursor: pointer;
                }
                button {
                    color: $white;
                    border: solid #eee 4px;
                    background-color: $primary;
                    @include fontBold();
                    padding: 10px 25px;
                    font-size: 18px;
                    line-height: 20px;
                    border-radius: 25px;
                    transition: all 0.4s ease;
                    position: absolute;
                    z-index: 1;
                    top: 50%;
                    left: 50%;
                    box-shadow:  0px 5px rgba(0, 0, 0, 0.1);
                    transform: translate(-50%, -50%);
                    @media (min-width: 1200px) {
                        z-index: -1;
                        opacity: 0;
                        visibility: hidden;
                    }
                    &:hover {
                        background-color: $secondary;
                        box-shadow:  0px 0px rgba(0, 0, 0, 0.5);
                    }
                }
            }
        }

        .workout_basket {
            padding: 15px;
            @media (min-width: 768px) {
                padding: 30px;
            }
            position: relative;
            .basket_container {
                position: relative;
                z-index: 1000;
            }
            &:after {
                display: block;
                content: "";
                position: absolute;
                top: -35px;
                bottom: 0;
                left: 0;
                right: 0;
                height: calc(100% + 75px);
                background-image: url('https://bigwavemedia.co.uk/workoutathome_system/images/header_bg.png');
                background-position: center;
                background-size: 100%;
                background-repeat: repeat;
                transform: skewY(1.5deg);
                transform-origin: 100%;
                @media (min-width: 768px) {
                    height: calc(100% + 120px);
                }
            }
            &:before {
                background: transparentize($primary, 0.5);
                background: -webkit-gradient(
                linear,
                left bottom,
                left top,
                from(transparentize(lighten($primary, 5%), 0.5)),
                color-stop(50%, transparentize($primary, 0.5)),
                to(transparentize(darken($primary, 5%), 0.5))
                );
                background: linear-gradient(
                0deg,
                transparentize(lighten($primary, 5%), 0.5),
                transparentize($primary, 0.5) 50%,
                transparentize(darken($primary, 5%), 0.5)
                );
                background-position: center;
                background-repeat: no-repeat;
                background-size: cover;
                content: "";
                display: block;
                height: calc(100% + 75px);
                position: absolute;
                top: -35px;
                left: 0;
                bottom: 0;
                right: 0;
                transform: skewY(1.5deg);
                transform-origin: 100%;
                z-index: -1;
                @media (min-width: 768px) {
                    height: calc(100% + 120px);
                }
            }
            h3 {
                color: $primary;
                margin-bottom: 30px;
                font-size: 32px;
                @include fontBlack();
            }
            ul {
                width: 100%;
                margin: 0;
                padding: 0;
                display: flex;
                align-items: center;
                justify-content: space-around;
                flex-wrap: wrap;
                flex-direction: row;
                @media (min-width: 1200px) {
                    flex-wrap: nowrap;
                }
                &.narrow {
                    @media (min-width: 1200px) {
                        max-width: 50%;
                        margin: auto;
                    }
                }
                li {
                    display: block;
                    list-style-type: none;
                    flex: 0 1 50%;
                    position: relative;
                    padding: 0 5px;
                    margin-bottom: 10px;
                    @media (min-width: 768px) {
                        margin-bottom: 30px;
                        padding: 0 15px;
                        flex: 0 1 33.333333%;
                    }
                    @media (min-width: 1200px) {
                        flex: 0 1 auto;
                        margin-bottom: 0;
                    }
                    &:hover {
                        button {
                            @media (min-width: 1200px) {
                                opacity: 1;
                                visibility: visible;
                                z-index: 1;
                            }
                        }
                    }
                    button {
                        color: $white;
                        border: solid #eee 4px;
                        border-radius: 50px;
                        background-color: $removeRed;
                        padding: 10px;
                        line-height: 18px;
                        z-index: 1;
                        transition: all 0.4s ease;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        @include fontBold();
                        width: 100px;
                        height: 100px;
                        @media (min-width: 768px) {
                            min-width: none;
                            max-width: none;
                        }
                        @media (min-width: 1200px) {
                            z-index: -1;
                            opacity: 0;
                            visibility: hidden;
                        }
                        &:hover {
                            background-color: darken($removeRed, 10%);
                        }
                    }
                    img {
                        width: 100%;
                        min-width: 0;
                        @media (min-width: 768px) {
                            width: auto;
                            max-height: 400px;
                            min-width: 0;
                        }
                    }
                }
            }
        }

        .lets_workout {
            margin-top: 105px;
            margin-bottom: 60px;
            @media (min-width: 576px) {
                margin-bottom: 105px;
            }
            @media (min-width: 768px) {
                margin-top: 150px;
            }
            button {
                margin: 0px auto 10px auto;
                @include fontBold();
                font-size: 20px;
                padding: 5px 20px;
                background-color: $primary;
                color: $white;
                border: none;
                border-radius: 30px;
                width: 70%;
                &:disabled {
                    background-color: transparentize($secondary, 0.5);
                }
                @media (min-width: 1200px) {
                    margin: 0 auto;
                }
            }
            .timer_display {
                p {
                    color: $primary;
                    font-size: 24px;
                    margin-top: 20px;
                    margin-bottom: 0;
                    @include fontBold();
                    @media (min-width: 1200px) {
                        font-size: 32px;
                    }
                }
                strong {
                    color: $primary;
                    @include fontBlack();
                    font-size: 40px;
                    line-height: 45px;
                    @media (min-width: 1200px) {
                        font-size: 60px;
                        line-height: 65px;
                    }
                }
            }

            .workout_instructions {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                height: 100%;
                padding: 0 25px;
                .workout_steps {
                    margin-bottom: 0;
                    margin-top: 35px;
                    @media (min-width: 1200px) {
                        margin-top: 0;
                    }
                    .step_a,
                    .step_b {
                        border-radius: 50%;
                        width: 50px;
                        height: 50px;
                        background-color: $secondary;
                        color: $white;
                        display: block;
                        margin: 0 auto 15px auto;
                        font-size: 30px;
                        font-weight: 700;
                        line-height: 50px;
                    }
                    h3 {
                        color: $secondary;
                        margin-bottom: 30px;
                        font-size: 20px;
                        @include fontBlack();
                    }
                    h4 {
                        margin-bottom: 0;
                        @include fontBlack();
                    }
                    .start_workout {
                        margin-bottom: 0;
                    }
                    > div {
                        margin-bottom: 30px;
                        img {
                            margin-bottom: 15px;
                        }
                        p {
                            font-size: 14px;
                        }
                    }
                }
            }
            .active_workout {
                h4 {
                    font-size: 22px;
                    @media (min-width: 1200px) {
                        font-size: 36px;
                    }
                    margin-bottom: 0;
                    @include fontBlack();
                }
                img {
                    margin-top: 5px;
                    padding: 5px;
                    border: 2px dotted $primary;
                    max-width: 320px;
                    @media (min-width: 576px) {
                        max-height: 600px;
                    }
                }
            }
            .next_workout {
                position: relative;
                .overlay {
                    position: absolute;
                    background-color: rgba(255, 255, 255, 0.6);
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                }
                img {
                    padding: 10px;
                    @media (min-width: 576px) {
                        max-height: 600px;
                    }
                }
            }
        }

        .social_share {
            padding: 30px;
            position: relative;
            &:after {
                display: block;
                content: "";
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background-image: url('https://bigwavemedia.co.uk/workoutathome_system/images/header_bg.png');
                background-position: center;
                background-size: cover;
                background-repeat: no-repeat;
                z-index: 1;
            }
            &:before {
                background: $primary;
                background: linear-gradient(
                0deg,
                lighten($primary, 5%) 0%,
                $primary 50%,
                darken($primary, 5%) 100%
                );
                background-position: center;
                background-repeat: no-repeat;
                background-size: cover;
                content: "";
                display: block;
                position: absolute;
                top: 0px;
                left: 0;
                bottom: 0;
                right: 0;
                z-index: -1;
            }
            .social {
                position: relative;
                z-index: 1000;
            }
            h2,
            p {
                color: white;
                text-align: center;
            }
            h2 {
                @include fontBlack();
            }
            p {
                @include fontBold();
            }
            span {
                background-color: $white;
                color: $primary;
                padding: 10px;
                border-radius: 50%;
                font-size: 22px;
                width: 40px;
                height: 40px;
                display: inline-block;
                position: relative;
                margin: 0 5px;
                svg {
                    cursor: pointer;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }

    .footer {
        background-color: #fff;
        padding: 15px 0;
        color: #000;
        @include fontBold();
        span {
            margin: 0;
            padding: 0;
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .slide-leave-active,
    .slide-enter-active {
        transition: 0.4s;
    }
    .slide-enter {
        opacity: 1;
        transform: translate(0, 100%);
    }
    .slide-leave-to {
        opacity: 0;
        transform: translate(0, -100%);
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 300px;
        @media (min-width: 768px) {
            width: 480px;
        }
        margin: 0px auto;
        padding: 5px;
        background-color: #fff;
        border-radius: 30px;
        border: 10px $primary solid;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h4 {
        margin-top: 0;
        text-align: centre;
        width: 100%;
        color: $primary;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        display: inline-block;
        background-color: $primary;
        color: #fff;
        min-width: 100%;
        padding: 10px;
        font-size: 18px;
        text-align: center;
        font-weight: bold;
        border: none;
        border-radius: 15px;
        transition: 0.3s;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>
